export const setKeywordListNewsletter = (
  content: string,
  searchTerms: Array<string> = []
) => {
  let formattedContent = content;

  // Clean up special characters but keep dots and quotes
  const cleanedSearchTerms = searchTerms.map((term) =>
    term.replace(/[^a-zA-Z0-9_\s".]/g, '')
  );

  const isExactPhrase = (str: string) => {
    return str.startsWith('"') && str.endsWith('"');
  };

  // Helper to escape regex special chars
  const escapeRegex = (str: string) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const processedPatterns = cleanedSearchTerms
    .filter((term) => term.trim().length > 0)
    .map((term) => {
      if (isExactPhrase(term)) {
        // Remove surrounding quotes
        const phrase = term.slice(1, -1).trim();

        // Escape regex special chars
        const escaped = escapeRegex(phrase);

        // Match full phrase but allow punctuation boundaries
        // Example: "pupuk pusat" matches in "pupuk pusat," or "(pupuk pusat)"
        return `(?<![\\w])${escaped}(?![\\w])`;
      } else {
        // Split into individual words for non-exact terms
        return term
          .split(/\s+/)
          .filter(Boolean)
          .map((word) => escapeRegex(word));
      }
    })
    .flat();

  let finalKeywordList = [];

  if (processedPatterns.length > 0) {
    const searchPattern = processedPatterns.join('|');
    const highlightRegex = new RegExp(`(${searchPattern})`, 'gi');

    formattedContent = content.replace(highlightRegex, (match) => {
      if (!finalKeywordList.includes(match)) {
        finalKeywordList.push(match);
      }
      return `<span style='background-color: rgb(255, 255, 0);'>${match}</span>`;
    });
  }

  return finalKeywordList;
};
